import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isQrCodeModal: false,
  isDownloadSuccessModal: false,
  showAgainDownloadSuccessModal: true,
  isFramesModal: false,
  isLogoModal: false,
  isStorageModal: false,
  framesModalCategory: "",
  isTemplateApply: false,
  isPreviewMobile: false,
  isBackgroundImageModal: false,
  isArtQrModal: false,
  isClassicQrModal: false,
  isTrialModal: false,
};

const modals = createSlice({
  name: "modals",
  initialState,
  reducers: {
    setIsQrCodeModal(state, { payload }) {
      state.isQrCodeModal = payload;
    },
    setIsStorageModal(state, { payload }) {
      state.isStorageModal = payload;
    },
    setIsDownloadSuccessModal(state, { payload }) {
      state.isDownloadSuccessModal = payload;
    },
    setShowAgainDownloadModal(state, { payload }) {
      state.showAgainDownloadSuccessModal = payload;
    },
    setIsFramesModal(state, { payload }) {
      state.isFramesModal = payload;
    },
    setIsLogoModal(state, { payload }) {
      state.isLogoModal = payload;
    },
    setFramesModalCategory(state, { payload }) {
      state.framesModalCategory = payload;
    },
    setIsTemplateApplystate(state, { payload }) {
      state.isTemplateApply = payload;
    },
    setIsPreviewMobile(state, { payload }) {
      state.isPreviewMobile = payload;
    },
    setIsBackgroundImageModal(state, { payload }) {
      state.isBackgroundImageModal = payload;
    },
    setIsArtQrModal(state, { payload }) {
      state.isArtQrModal = payload;
    },
    setIsClassicQrModal(state, { payload }) {
      state.isClassicQrModal = payload;
    },
    setIsTrialModal(state, { payload }) {
      state.isTrialModal = payload;
    },
  },
});
export const {
  setIsQrCodeModal,
  setIsDownloadSuccessModal,
  setShowAgainDownloadModal,
  setIsFramesModal,
  setIsStorageModal,
  setIsLogoModal,
  setFramesModalCategory,
  setIsTemplateApplystate,
  setIsPreviewMobile,
  setIsBackgroundImageModal,
  setIsArtQrModal,
  setIsClassicQrModal,
  setIsTrialModal,
} = modals.actions;
export default modals.reducer;
